/**
 * 获取指定车型详细参数
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 获取车辆基本信息
// 接口地址  /api/v1/auctions/{auction_id}/basics
Mock.mock(/\/auctions\/car_models\/\d+/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'id': 102157,
    'brand': '其他',
    'manufacturer': '北京奔驰',
    'series': '奔驰GLC',
    'name': '奔驰GLC 2017款 200 4MATIC',
    'year': 2016,
    'extinfo': {
      'level': '其他',
      'displacement': '10.0L',
      'emission_standard': '欧VI',
      'engine_type': '其他',
      'fuel_type': '其他',
      'gearbox': '其他',
      'drivetrain': '其他',
      'guide_price': '39.60万'
    }
  }
})
